import React, { createContext, useState } from "react";

export const SectionContext = createContext();

export const SectionProvider = ({ children }) => {
  const [filteredsectionsEngineData, setFilteredsectionsEngineData] = useState(
    []
  );
  const [filteredsectionsMachineData, setFilteredsectionsMachineData] =
    useState([]);

  return (
    <SectionContext.Provider
      value={{
        filteredsectionsEngineData,
        setFilteredsectionsEngineData,
        filteredsectionsMachineData,
        setFilteredsectionsMachineData,
      }}
    >
      {children}
    </SectionContext.Provider>
  );
};
